import { useContent } from '../content/ContentContext.jsx'
import { Em } from '../components/Em.jsx'
import { MediaFill } from '../components/MediaFill.jsx'
import { SectionNum } from '../components/SectionNum.jsx'

export function PhilosophySection() {
  const { content } = useContent()
  const p = content.philosophy
  return (
    <section className="section philo" id="sec-philosophy">
      <SectionNum sectionKey="philosophy" />
      <div className="grid2">
        <div className="col-label">
          <div className="caption">{p.caption}</div>
        </div>
        <div>
          <h2>
            <Em pre={p.pre} em={p.em} post={p.post} />
          </h2>
          <p className="pull">&ldquo;{p.quote}&rdquo;</p>
          <p className="body-p">{p.body1}</p>
          <p className="body-p">{p.body2}</p>
          <div className="img-slot img-tall" style={{ marginTop: 34, maxWidth: 380 }}>
            <MediaFill id={p.image} />
            <div className="cap caption">{p.caption}</div>
          </div>
        </div>
      </div>
    </section>
  )
}
